import { Component, Input, OnInit} from '@angular/core';
import { FormGroup } from '@angular/forms';
import { EFormHelper } from 'app/e-form/helper/script/helper';
import { State } from 'app/e-form/model/eform-type';
import { Observable } from 'rxjs';

@Component({
  selector: 'app-signature-properties',
  templateUrl: './signature-properties.component.html',
  styleUrls: ['./signature-properties.component.scss']
})
export class SignaturePropertiesComponent implements OnInit {
   @Input() eForm: FormGroup;
   @Input() state: State;
   helper = new EFormHelper();
   displayDisabled: boolean;
   @Input() eventsStateChild: Observable<void>;
   constructor() { }

   ngOnInit(): void {
      this.helper.checkDisplayDisabled(this.eForm, this.state);
      this.helper.displayDisabledChanges.subscribe((value) => {
         this.displayDisabled = value;
      });
      this.eventsStateChild.subscribe(() => {
         this.helper.checkDisplayDisabled(this.eForm, this.state);
      });
   }

}
